/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react'
import * as Yup from 'yup'
import { Link, useNavigate } from 'react-router-dom'
import { Field, FormikProvider, useFormik } from 'formik'
import { EMAIL_REQUIRED, INVALID_EMAIL_MESSAGE, LOGIN_SUCCESS, PASSWORD_LENGTH_MESSAGE, PASSWORD_REQUIRED } from '../../../utlis/messages'
import FieldInputText from '../../common/FieldInputText'
import SubmitButton from '../../common/SubmitButton'
import { login } from '../../../redux/features/auth/authActions'
import { useDispatch, useSelector } from 'react-redux'
// import logoDarkPink from "../../../../_metronic/assets/images/logoDarkPink.png"
import { successMessage } from '../../../utlis/common'

const validationSchema = Yup.object({
  email: Yup.string()
    .email(INVALID_EMAIL_MESSAGE)
    .required(EMAIL_REQUIRED),
  password: Yup.string()
    .min(8, PASSWORD_LENGTH_MESSAGE)
    .required(PASSWORD_REQUIRED),
});

const initialValues = {
  email: '',
  password: '',
}

export function Login() {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const authState = useSelector((state: any) => state.auth);

  useEffect(() => {
    if (authState.token) {
      navigate('/devices'); // Redirect when token exists
    }
  }, [authState.token, navigate]); // Depend on `authState.token`


  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      try {
        const response = await dispatch(login(values)); // Dispatch login action
        navigate('/devices'); // Redirect to Device list page on success
      } catch (error) {
        console.error("Login failed:", error);
        setStatus("Login failed");
      }
    },
  });

  return (
    <FormikProvider value={formik}>
      <form
        className='form w-100 authWrapper'
        onSubmit={formik.handleSubmit}
        noValidate
        id='kt_login_signin_form'
      >
        <div className='text-center mb-11'>
          <div className='text-center logo-wrap'>
            {/* <img src={logoDarkPink} alt='logo'/> */}
          </div>
          <h1 className='text-dark fw-bolder mb-3'>Benvenuto in Iot HUB</h1>
        </div>

        <div className='fv-row mb-8'>
          <Field
            name="email"
            validate={validationSchema}
            label="E-mail"
            type="email"
            required={true}
            component={FieldInputText}
            placeholder="E-mail"
          />
        </div>

        <div className='fv-row mb-3'>
          <Field
            name="password"
            validate={validationSchema}
            label="Password"
            type="password"
            required={true}
            component={FieldInputText}
            placeholder="Password"
          />
        </div>

        <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
          <div />
          <Link to='/auth/forgot-password' className='link-primary'>
            Ha dimenticato la password?
          </Link>
        </div>

        <div className='d-grid mb-10'>
          <SubmitButton title="Invia" type="submit" loading={authState.loading} />
        </div>

        {/* Add Sign-up Link */}
        <div className='text-center mt-5'>
          <span className='text-gray-600 fw-semibold'>Non Hai ancora un'account?{" "}
            <Link to='/auth/registration' className='link-primary'>
              Richiedi accesso
            </Link>
          </span>
        </div>
      </form>
    </FormikProvider>
  )
}
